import { useEffect, useState } from 'react';

export const useMobile = () => {
  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isMobileExtended: false,
      isMobileExtendedPlus: false,
    };
  }

  const [width, setWidth] = useState(window?.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return {
    isMobile: width < 768,
    isMobileExtended: width < 1024,
    isMobileExtendedPlus: width < 1311,
  };
};
